import usuariosMenu from './usuarios/menu';
import perfisMenu from './perfisacesso/menu';
import regrasMenu from './regrasacesso/menu';
import aplicacoesMenu from './aplicacoes/menu';

const menu = {
    label: 'Controle de Acesso',
    icon: 'pi pi-fw pi-id-card',
    rules: [...usuariosMenu.rules, ...perfisMenu.rules, ...regrasMenu.rules, ...aplicacoesMenu.rules],
    items: [usuariosMenu, perfisMenu, regrasMenu, aplicacoesMenu],
};

export default menu;
